import { render, staticRenderFns } from "./phone-remark-modify.vue?vue&type=template&id=37810177"
import script from "./phone-remark-modify.vue?vue&type=script&lang=ts"
export * from "./phone-remark-modify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports